
import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { id } from "@swimlane/ngx-datatable/release/utils";
import { ToasterService } from "angular2-toaster";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import {
    CommonService,
    Combo2Service
  } from "../../../services/index";
  import { SalesInvoiceService } from "../../../services/salesinvoice.service";
// import { PrintWorkOrder } from "./printWO";
// import { workorderprint } from "./woprint";
declare var google;

@Component({
    selector: "addedit-invoice-tab",
    host: { "(window:keydown)": "hotkeys($event)" },
    templateUrl: "shirtTypeupdate.html",
  })
 
export class shirtTypeupdate implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  verifierId: number;
  verifier: string;
  cancelWo_no: string;
  seasonList = [];
  gridOptions: any;
  dataList = [];
//   orderList: any = [];
  approver: string;
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;

  // groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  // filter = {
  //   wo_no: "",
  //   order_from_date: "",
  //   order_to_date: "",
  //   wo_from_date: "",
  //   wo_to_date: "",
  //   wo_ret_id:"",
  //   finyear: "2019-2020"
  // };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "wo_id",
    orderDir: "desc"
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];
  approvedList =["Approved", "Not Approved", "All"];
 

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @ViewChild("printTemplate") printTemplate;
  @ViewChild("cancelTemplate") cancelTemplate;
  @ViewChild("approveTemplate") approveTemplate;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  update_id :number;
  agentVisible: boolean = false;
  showApprove : boolean = false;
  showColumns : boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private commonService: CommonService,
    public toasterService: ToasterService,
    private salesinvservice: SalesInvoiceService,
    public datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
    // this.data = {
    //   grnList: [],
    // };
  }

  hotkeys(event) {
    if (this.active) {
    }
  }
  addEditshirtType(mode: string, row: any): void {
    // this.filterExpand = true;
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getShirtTypeupdateList()
    //   this.filterExpand = true;

    // this.getShirtTypeupdateList()
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "CONVERT SHIRT TYPES",
          title: "CONVERT SHIRT TYPES",
          tabParent: "MASTER",
          mode: mode,
          data: row,
          name: "convertShirtTypes",
        },
      };
    }
    else if(mode == "View"){
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "CONVERT SHIRT TYPES",
          title: "CONVERT SHIRT TYPES",
          tabParent: "MASTER",
          mode: mode,
          data: row,
          name: "convertShirtTypes",
        },
      };
    }
    this.tabUpdateEvent.emit(tabObj);
  }
  // viewStockreport(row){
  //   this.update_id = row.update_id;
  //   // this.getColumns();
  // }
  getColumns() {
 
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center"
      },
    
     
  
      {
        name: "Date",
        prop: "date",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120
      },
     
      {
        name: "Time",
        prop: "time",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120
      },
      {
        name: "FROM",
        prop: "from_type",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120
      },
      {
        name: "To",
        prop: "to_type",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120
      },
      {
        name: "No of pcs",
        prop: "totpcs",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120
      },
      {
        name: "Action",
        prop: "sno",
        minWidth: 100,
        maxWidth: 120,
        width: 110,
        sortable: false,
        cellTemplate: this.editDeleteTemplate
      }

    ];


  this.pageCallback({ offset: 0 });
    this.toggleCol = Object.assign({}, this.columns);

}

  onOpenedFilter(): void {
    setTimeout(function() {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }
//   finyearCombo() {
//     // if(this.filter.wo_ret_id !==""){
//     //   this.filter.wo_ret_id ="";
//     // }
//     let that = this;
//     this.combo2Service.finyearCombo().then((res: any) => {
//       that.finyearList = res.data;
//       that.filter.finyear = res.data[0].finyear;
//       that.pageCallback({ offset: 0 });
//     });
//   }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getShirtTypeupdateList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  clearFilter(): void {

    // this.filter.wo_no = "";
    // this.filter.order_from_date = "";
    // this.filter.order_to_date = "";
  //  this.filter.wo_from_date = '';
  //   this.filter.wo_to_date = "";
  
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    // this.getShirtTypeupdateList();
  }
  gobacktoGroup(){
    this.showApprove = false;
    // this.filter.wo_ret_id = "";
    this.showColumns = true;
    this.getColumns();
    // this.getColumns();

  }
  // loadSeasonList() {
  //   let that = this;
  //   this.combo2Service.seasonCombo().then(function(res) {
  //     //  this.LoadAgentList();
  //     that.seasonList = res.data;
  //     that.seasonCtrl.setValue(res.data[0].season_id);
  //   });
  // }

  viewReturndetails(row){
 
    //  this.filter.wo_ret_id = row.wo_ret_id;
    //  this.showColumns = true
    //  this.getColumns(this.showColumns);
    // this.getShirtTypeupdateList();
  }

  
 
 getShirtTypeupdateList(): void {
     let params ={};
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.salesinvservice
      .getShirtTypeupdateList(params)
      .then(function(res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;
      });
  }

}





// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/convertShirtTypes/shirtTypeupdate.ts